// TODO: change both urls when these screens are made

export const SEARCH_PARAMS_KEYS = {
  verificationId: 'verificationId',
  userId: 'userId',
  verificationRequestId: 'verificationRequestId',
  componentId: 'componentId',
  claimId: 'claimId',
  clientContractId: 'clientContractId',
  applicantId: 'applicantId',
  set: 'set',
  reset: 'reset',
  email: 'email',
  passwordChangeType: 'passwordChangeType',
  context: 'context',
  token: 'token',
  setPasswordType: 'setPasswordType',
  signUp: 'signUp',
  skipProfession: 'skipProfession',
  applicantUserId: 'applicantUserId',
  country: 'country',
  authority: 'authority',
  skipSelectComponent: 'skipSelectComponent',
  originalVerificationRequestId: 'originalVerificationRequestId',
  parentVerificationRequestId: 'parentVerificationRequestId',
  clientShortCode: 'clientShortCode',
  purposeId: 'purposeId',
  purposeCategoryId: 'purposeCategoryId',
  paymentByPartner: 'paymentByPartner',
  paymentTransactionId: 'paymentTransactionId',
  caseId: 'caseId',
  isMigrationFlow: 'isMigrationFlow',
  error: 'error',
  errorDescription: 'error_description',
  uaePassState: 'state',
  type: 'type',
  redirectAfterFetchReport: 'redirectAfterFetchReport',
  passportNo: 'passportNo',
  dob: 'dob',
  phoneNo: 'phoneNo',
  skipEducation: 'skipEducation',
  documentId: 'documentId',
  caseIds: 'caseIds',
  isAdditionalComponentVerificationRequestAllowed:
    'isAdditionalComponentVerificationRequestAllowed',
  additionalClientIds: 'additionalClientIds',
  allowedVRStatuses: 'allowedVRStatuses',
  partnerInvite: 'partnerInvite',
  countryName: 'countryName',
  countryFlagUrl: 'countryFlagUrl',
  clientName: 'clientName',
  clientLogoUrl: 'clientLogoUrl',
  purposeName: 'purposeName',
  purposeCategoryName: 'purposeCategoryName',
  isAdditionalComponents: 'isAdditionalComponents',
  reportTransferAllowedInContract: 'reportTransferAllowedInContract',
  isOnlyAdditionalDocumentVerificationAllowed:
    'isOnlyAdditionalDocumentVerificationAllowed',
  renewalEnabled: 'renewalEnabled',
  fileId: 'fileId',
  verificationRequestIds: 'verificationRequestIds',
  /** Set when opening payment details from the verification list Payment Pending tab (bulk pay). */
  fromPaymentPendingTab: 'fromPaymentPendingTab',
  authorityId: 'authorityId',
  authorityName: 'authorityName',
  categoryId: 'categoryId',
  categoryName: 'categoryName',
  applicationBatchId: 'applicationBatchId'
};

export const PAGE_URLS = {
  faq: 'https://support.dataflowgroup.com/',
  home: '/dashboard/home',
  verification: '/dashboard/verification',
  onboardingAddEmail: '/onboarding/add-email',
  onboardingAddAboutYourself: '/onboarding/about-yourself',
  onBoardinSignin: '/onboarding/log-in',
  onboardingVerificationMobile: '/onboarding/verification/mobile',
  onboardingVerificationEmail: '/onboarding/verification/email',
  vip: 'https://www.dataflowgroup.com/vip/',
  splash: '/onboarding/splash',
  aboutUsWhoWeAre: 'https://www.dataflowgroup.com/about-us/who-we-are/',
  termsAndConditions: 'https://www.dataflowgroup.com/terms-conditions/',
  privacyPolicy:
    'https://www.dataflowgroup.com/about-us/our-policies/general-applicant-privacy-policy/',
  accessSupport: 'https://support.dataflowgroup.com/',
  contactDetails: '/verification/contact-details'
};

export const VERIFICATION_URLS = {
  aboutApplicant: '/verification/about-applicant',
  selectCountry:
    '/verification/select-country?applicantId=#{applicantId}&applicantUserId=#{applicantUserId}',
  selectAuthority: '/verification/select-authority',
  addSpeciality: '/verification/add-speciality',
  pqrSelection: '/verification/pqrSelection',
  iaAttribution: '/verification/ia-attribution',
  requiredDocuments: '/verification/required-documents',
  selectDocuments: '/verification/select-documents',
  selectIssuers: '/verification/select-issuers',
  overviewSummary:
    '/verification/overview-summary?verificationRequestId=#{verificationRequestId}',
  overview:
    '/verification/overview?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}',
  letterOfAuth: `/verification/letter-of-auth?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&isMigrationFlow=#{isMigrationFlow}`,
  pricingDetailsUrl: `/verification/pricing-details?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}`,
  paymentPendingPricingDetailsUrl: `/verification/payment-pending-pricing-details?verificationRequestId=#{verificationRequestId}&verificationRequestIds=#{verificationRequestIds}`,
  verificationInsufficiency: `/verification/verification-insufficiency?verificationId=#{verificationId}&applicantUserId=#{applicantUserId}`,
  verificationInsufficiencyOverview: `/verification/verification-insufficiency/overview?verificationId=#{verificationId}&applicantUserId=#{applicantUserId}`,
  uploadDocumentsForVerification:
    '/verification/document-upload?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&isMigrationFlow=#{isMigrationFlow}',
  uploadDocumentsForEditComponent:
    '/verification/document-upload?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&componentId=#{componentId}',
  pricingEstimation:
    '/verification/pricing-estimate?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}',
  insufficiencyPricingEstimation:
    '/verification/insufficiency-pricing-details?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&insufficiency=true',
  appealRequest:
    '/verification/appeal-request?verificationRequestId=#{verificationRequestId}',
  requestCorrection:
    '/verification/request-correction?verificationRequestId=#{verificationRequestId}',
  paymentStatus:
    '/verification/payment-status?PaymentTransactionId=#{PaymentTransactionId}&paymentStatus=#{paymentStatus}&verificationRequestId=#{verificationRequestId}',
  additionalComponents:
    '/verification/additional-components?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&parentVerificationRequestId=#{parentVerificationRequestId}',
  reportTransfer:
    '/verification/report-transfer?verificationRequestId=#{verificationRequestId}&skipEducation=#{skipEducation}&skipProfession=#{skipProfession}&applicantUserId=#{applicantUserId}&skipSelectComponent=#{skipSelectComponent}',
  nameChange:
    '/verification/name-change?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}',
  paymentDetails:
    '/verification/payment-details?verificationRequestIds=#{verificationRequestIds}',
  inviteSent: '/verification/invite-sent',
  loaInviteSent:
    '/verification/loa-invite-sent?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&paymentByPartner=#{paymentByPartner}',
  submitApplication: `/verification/submit-application?verificationRequestId=#{verificationRequestId}`,
  additionalAuthentication:
    '/verification/additional-authentication?type=#{type}&verificationRequestId=#{verificationRequestId}&error=#{error}',
  VRSuccess: '/verification/vr-success',
  approvalSent: `/verification/approval-sent?verificationRequestId=#{verificationRequestId}`,
  clientRequirementListTab:
    '/verification/client-requirement-list-tab?verificationRequestId=#{verificationRequestId}&crlId=#{crlId}&applicantUserId=#{applicantUserId}',
  addSpecialityUrl:
    '/verification/add-speciality?authority=#{authority}&country=#{country}',
  existingReports: `/verification/find-report/existing-reports?passportNo=#{passportNo}&dob=#{dob}&${SEARCH_PARAMS_KEYS.redirectAfterFetchReport}=#{${SEARCH_PARAMS_KEYS.redirectAfterFetchReport}}&${SEARCH_PARAMS_KEYS.applicantUserId}=#{${SEARCH_PARAMS_KEYS.applicantUserId}}`,
  reportDocumentDetails: `/verification/find-report/report-document-details?documentId=#{documentId}&${SEARCH_PARAMS_KEYS.redirectAfterFetchReport}=#{${SEARCH_PARAMS_KEYS.redirectAfterFetchReport}}&${SEARCH_PARAMS_KEYS.applicantUserId}=#{${SEARCH_PARAMS_KEYS.applicantUserId}}`,
  fetchReportDetails: `/verification/find-report/fetch-report-details?${SEARCH_PARAMS_KEYS.redirectAfterFetchReport}=#{${SEARCH_PARAMS_KEYS.redirectAfterFetchReport}}&${SEARCH_PARAMS_KEYS.applicantUserId}=#{${SEARCH_PARAMS_KEYS.applicantUserId}}`,
  findReport: `/verification/find-report?${SEARCH_PARAMS_KEYS.redirectAfterFetchReport}=#{${SEARCH_PARAMS_KEYS.redirectAfterFetchReport}}&${SEARCH_PARAMS_KEYS.applicantUserId}=#{${SEARCH_PARAMS_KEYS.applicantUserId}}`,
  fetchReportPricing:
    '/verification/fetch-report-pricing?verificationRequestId=#{verificationRequestId}',
  fetchReportReissuePricing:
    '/verification/reissue-report?verificationRequestId=#{verificationRequestId}',
  browseExistingCases: '/verification/browse-existing-cases'
};

export const DASHBOARD_URLS = {
  credential: `/dashboard/vault/identity`,
  addCreditional: `/dashboard/vault/add-identity`,
  verificationDetails: `/dashboard/verification/verification-details?verificationId=#{verificationId}&applicantUserId=#{applicantUserId}`,
  VERIFICATION_UPDATE: `/dashboard/verification/update?verificationId=#{verificationId}`,
  userProfile: '/dashboard/user-profile',
  transactions: '/dashboard/transactions',
  manageAccount: '/dashboard/manage-account',
  notificationPreferences: '/dashboard/manage-account/notification-preferences',
  notificationCategory: '/dashboard/notification-category',
  approvalPending: '/dashboard/approval-pending',
  partnerHomePage: '/dashboard/home'
};

export const DASHBOARD_URL_QUERY_PARAMS = {
  component: 'component'
};

export const VERIFICATION_EXTRA_URLS = {
  icon: `${process.env.NEXT_PUBLIC_STATIC_URL}/images/svg`,
  countryIcon: `${process.env.NEXT_PUBLIC_STATIC_URL}/images`,
  documentIcon: `${process.env.NEXT_PUBLIC_STATIC_URL}/images/docs`,
  country: 'country',
  authority: 'authority',
  addSpeciality: 'add-speciality',
  clientShortCode: 'clientShortCode'
};

export const NOTIFICATIONS_URLS = {
  home: '/dashboard/home/notifications',
  noNotificationImgPath: '/assets/image/amico.png'
};

export const DATAFLOW_LOGO_URL = `${process.env.NEXT_PUBLIC_STATIC_URL}/images/dataFlowLogo.png`;

export const LOCAL_STORAGE_KEYS = {
  applicantsDetail: 'applicantsDetail',
  invitedVerificationRequestIds: 'invitedVerificationRequestIds'
};

export const TICK_GIF_URL = `${process.env.NEXT_PUBLIC_STATIC_URL}/images/tick_loader.gif`;

export const NO_RECOR_FOUND_IMAGE = `${process.env.NEXT_PUBLIC_STATIC_URL}/images/no-record-found.png`;

export const LEAD_MANAGEMENT_URLS = {
  category: `services/category?source=#{source}&categoryId=#{categoryId}`,
  adDetails: `/services/ad-details?adId=#{adId}`,
  servicesBySource: `/dashboard/services?source=#{source}`,
  ancillaryPaymentStatus: '/services/payment-status?orderId=#{orderId}',
  ancillaryPaymentBreakdown: '/services/payment-breakdown?orderId=#{orderId}'
};

export const NO_PAST_RECORDS_IMG_URL = `${process.env.NEXT_PUBLIC_STATIC_URL}/images/noPastReports.png`;

export const VALID_FILE_TYPES = ['PNG', 'JPG', 'PDF', 'JPEG'];

export const BULK_UPLOAD_VALID_FILE_TYPES = [
  'PNG',
  'JPG',
  'PDF',
  'JPEG',
  'ZIP'
];

export const IMAGE_FILE_TYPES = ['jpg', 'jpeg', 'png'];

export const DOCX_FILE_TYPES = ['DOC', 'DOCX'];

export const BIRTH_DATE_YEARS_AGO = 13;

export const FILE_TYPE_MAP = {
  image: 'image',
  pdf: 'pdf',
  applicationPDF: 'application/pdf',
  images: 'image/'
} as const;

export const HTTP_PROTOCOLS = {
  http: 'http',
  https: 'https'
} as const;
export const BULK_APPLICATION_VALID_FILE_TYPES = ['CSV', 'XLS'];
